import '@babel/polyfill';
// Import Component hooks before component definitions
import '@/component-hooks';
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import '@/plugins/vee-validate';
import '@/plugins/v-mask';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/registerServiceWorker';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';
import formatting from '@/formatting';
import vueDebounce from 'vue-debounce';

Vue.config.productionTip = false;

Vue.filter('dynamicFilter', (value: string, name: string, ...args: any[]) => {
  if (name) {
    return Vue.filter(name)(value, ...args);
  } else {
    return value;
  }
});

Vue.filter('uppercase', (value: string) => {
  return value.toUpperCase() || '';
});
Vue.filter('date', (value: string) => {
  return formatting.formatDate(value) || '';
});
Vue.filter('timestamp', (value: string) => {
  return formatting.formatTimeStamp(value) || '';
});
Vue.filter('datetime', (value: string) => {
  return formatting.formatDateTime(value) || '';
});
Vue.filter('euro', (value: string) => {
  if (value != null) {
    const n = Number(value);
    const formatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    });
    return formatter.format(n);
  } else {
    return '';
  }
});
Vue.filter('percentage', (value: string) => {
  if (value) {
    return value + '%';
  } else {
    return '';
  }
});
Vue.filter('boolean', (value: number) => {
  if (value === 0) {
    return 'Nee';
  } else if (value === 1) {
    return 'Ja';
  } else {
    return '';
  }
});
Vue.filter('boolean-string', (value: string) => {
  if (value !== null) {
    return 'Ja';
  } else {
    return 'Nee';
  }
});
Vue.filter('number', (value: string) => {
  if (value != null) {
    const n = Number(value);
    const formatter = new Intl.NumberFormat('nl-NL');
    return formatter.format(n);
  } else {
    return '';
  }
});
Vue.filter('document-type', (value: string) => {
  const documentTypes = {
    quote: 'Offerte',
    order: 'Werkbon',
    invoice: 'Factuur',
    credit_note: 'Kredietnota',
    quote_template: 'Template'
  };
  return documentTypes[value] ? documentTypes[value] : '';
});
Vue.use(vueFilterPrettyBytes);
Vue.use(vueDebounce);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
